import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import {CopyToClipboard} from 'react-copy-to-clipboard';

const useStyles = makeStyles((theme) => ({
  displayValue: {
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'row',
  },
  placeholder: {
    minWidth: '20px',
  },
}));

export default function FieldValue(props) {
  const { value, variant, maxLength, onClick, formatter } = props;
  const classes = useStyles();
  
  const [ showCopy, setShowCopy ] = React.useState(false);
  const [ copied, setCopied ] = React.useState(false);

  let displayValue = formatter?formatter(value):value;
  displayValue = (maxLength && displayValue.length>maxLength)?displayValue.substring(0,maxLength)+"...":displayValue;
  
  const handleClick = () => {
    if(onClick) {
      onClick(value);
    }
  };
  
  return (
    <div className={classes.displayValue} 
        onMouseEnter={() => setShowCopy(true)} 
        onMouseLeave={() => setShowCopy(false)}>
      <Tooltip title={value!==displayValue?value:""} placement="top" arrow>
        <Typography variant={variant} onClick={handleClick}>{displayValue}</Typography>
      </Tooltip>
      &nbsp;
      {showCopy?
      <Tooltip title={copied?"Copied":"Copy to clipboard"} placement="top-start" arrow>
        <CopyToClipboard text={value} onCopy={() => setCopied(true)}>
          <FileCopyOutlinedIcon fontSize='small' onMouseLeave={() => setCopied(false)}/>
        </CopyToClipboard>
      </Tooltip>:
      <div className={classes.placeholder}/>  
      }
    </div>
  );
}

FieldValue.propTypes = {
  value: PropTypes.any.isRequired,
  variant: PropTypes.string.isRequired,
  maxLength: PropTypes.number,
  onClick: PropTypes.func,
  formatter: PropTypes.func,
};

FieldValue.defaultProps = {
  variant: "inherit",
};
